import { CardModule } from "primeng/card";
import { CodemirrorModule } from "@ctrl/ngx-codemirror";
import { CommonModule, NgClass } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { defineElement } from "@lordicon/element";
import { DropdownsModule } from "../dropdowns/dropdowns.module";
import { FormsModule } from '@angular/forms';
import lottie from 'lottie-web';
import { NgbDropdownModule, NgbNavModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PageCompControlRibbonComponent } from "./page-comp-control-ribbon/page-comp-control-ribbon.component";
import { PageCompDownloadBoxComponent } from "./page-comp-download-box/page-comp-download-box.component";
import { PageCompHeaderComponent } from './page-comp-header/page-comp-header.component';
import { PageCompHtmlEditorViewerComponent } from "./page-comp-html-editor-viewer/page-comp-html-editor-viewer.component";
import { PageCompMenuBootstrapComponent } from "./page-comp-menu-bootstrap/page-comp-menu-bootstrap.component";
import { PageCompMenuPrimeNgComponent } from "./page-comp-menu-primeng/page-comp-menu-primeng.component";
import { PageCompMenuNotificationsComponent } from "./page-comp-menu-notifications/page-comp-menu-notifications.component";
import { PageCompTimelineComponent } from './page-comp-timeline/page-comp-timeline.component';
import { SharedModule } from '../../shared/shared.module';
import { TimelineModule } from "primeng/timeline";
import { ToastsContainer } from 'src/app/shared/toast/toasts-container.component';

@NgModule({
  declarations: [
    PageCompControlRibbonComponent,
    PageCompDownloadBoxComponent,
    PageCompHeaderComponent,
    PageCompHtmlEditorViewerComponent,
    PageCompMenuBootstrapComponent,
    PageCompMenuNotificationsComponent,
    PageCompMenuPrimeNgComponent,
    PageCompTimelineComponent
  ],
  imports: [
    CardModule,
    CodemirrorModule,
    CommonModule,
    DropdownsModule,
    FormsModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbTooltipModule,
    NgClass,
    OverlayPanelModule,
    SharedModule,
    TimelineModule,
    ToastsContainer
  ],
  exports: [
    PageCompControlRibbonComponent,
    PageCompDownloadBoxComponent,
    PageCompHeaderComponent,
    PageCompHtmlEditorViewerComponent,
    PageCompMenuBootstrapComponent,
    PageCompMenuNotificationsComponent,
    PageCompMenuPrimeNgComponent,
    PageCompTimelineComponent
  ],
  providers: [
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class PageComponentsModule {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
